module.exports = __webpack_public_path__ + "img/Triangle-logo.898c9ca6.svg";